import React, { useState, useEffect } from "react";
import axios from "axios";
import style from "../Demomodal/Demomodal.module.css";
import { API_BASE_URL, contactus_api } from "../../../Apiconfig";

const Demomodal = ({ onClose }) => {
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    useEffect(() => {
        // Automatically close the modal when `onClose` is triggered
        if (!isModalOpen) {
            onClose();
        }
    }, [isModalOpen, onClose]);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const [formData, setFormData] = useState({
        name: "",
        Businessname: "",
        contactno: "",
        city: "",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleCheckboxChange = (e) => {
        setIsCheckboxChecked(e.target.checked); // Update checkbox state
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Replace the URL with your backend API endpoint
            const response = await axios.post(
                `${contactus_api}demo_Queries.php`,
                formData,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            // Check the response from the backend
            if (response.data.success) {
                // alert(response.data.message);
                setSuccessMessage("Request Sand Successfully!");  // Set the success message
                setTimeout(() => setSuccessMessage(""), 1000);
                setFormData({ name: "", Businessname: "", contactno: "", city: "" }); // Reset the form
                setIsCheckboxChecked(false);
            } else {
                alert(response.data.message); // Error message from the backend
            }
        } catch (error) {
            console.error("Error submitting the form:", error);
            alert("Failed to submit the form. Please try again later.");
        }
    };

    return (
        <>
            <div className={style.Smodaloverlay} onClick={toggleModal}></div>
            <div className={style.Smodalcontainer}>
                <h4 className={style.oneonone}>Schedule a One-on-One Demo with India`s 1st</h4>
                <h4 className={style.mainsubheading}>Kirana Shop Manage</h4>
                <div className={`${style.box} row`}>
                    <div className={`${style.box1} col-lg-6`}>
                        <div className={style.boxrow1}>
                            <img
                                className={style.imgone}
                                src="/Images/abcd.png"
                                alt=""
                            />
                        </div>
                        <div className={`${style.boxrow2} row`}>
                            <div className={`${style.boxcol1} col-4 row`}>
                                <div className={`${style.iconbox} col`}>
                                    <i className={`${style.icon} fa-solid fa-cart-arrow-down`}></i>
                                </div>
                                <div className="col"><h6>Sell in-Store & Online</h6></div>
                            </div>
                            <div className="col-4">
                                <div className={`${style.iconbox} col`}><i className={`${style.icon} fa-solid fa-chart-pie`}></i></div>
                                <div className="col"><h6>Smart Business Analytics</h6></div>
                            </div>
                            <div className="col-4">
                                <div className={`${style.iconbox} col`}><i className={`${style.icon} fa-solid fa-mobile-screen`}></i></div>
                                <div className="col"><h6>Access Anytime Anywhere</h6></div>
                            </div>
                        </div>

                    </div>
                    <div className={`${style.box2} col-lg-6`}>
                        <form className={style.demoform} onSubmit={handleSubmit}>
                            <p className={style.formtitle}>
                                Kirana Manage!!! <br /> Request a free Demo
                            </p>
                            <div className={style.inputcontainer}>
                                <input placeholder="Name" type="text" id="name"
                                    name="name" value={formData.name} onChange={handleInputChange} required />
                            </div>
                            <div className={style.inputcontainer}>
                                <input placeholder="Business Name" type="text" id="Businessname"
                                    name="Businessname" value={formData.Businessname} onChange={handleInputChange} required />
                            </div>
                            <div className={style.inputcontainer}>
                                <input placeholder="Contact Number" type="number" id="contactno"
                                    name="contactno" value={formData.contactno} onChange={handleInputChange} required />
                            </div>
                            <div className={style.inputcontainer}>
                                <input placeholder="City" type="text" id="city"
                                    name="city" value={formData.city} onChange={handleInputChange} required />
                            </div>
                            <div className={style.checkboxcontainer}>
                                <input
                                    type="checkbox"
                                    id="rememberMe"
                                    checked={isCheckboxChecked} // Controlled by state
                                    onChange={handleCheckboxChange}
                                    required />
                                <label
                                    className={style.checkboxlabel}
                                    htmlFor="rememberMe"
                                >
                                    I hereby provide my consent to receive emails, phone
                                    calls. messages and other communications from K.M to
                                    understand about K.M services, offerings, promotions and
                                    other related information.
                                </label>
                            </div>
                            <button className={style.submit} type="submit">
                                Book a Demo!!!
                            </button>
                        </form>
                    </div>
                </div>
                <button className={style.Smodalclosebtn} onClick={toggleModal}>
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
            {/* Success message */}
            {successMessage && (
                <div className={style.successMessage}>
                    {successMessage}
                </div>
            )}
        </>
    );
};

export default Demomodal;
